import React, { useContext } from 'react';
import tobeor from 'tobeor';

import { withStyles } from '@mui/styles';
import EventsStyles from '../EventsStyles';

import Node from '../../../common/Node';
import CommonStyles from '../../../common/CommonStyles';

import CreateNewSubBtn from './CreateNewSubBtn';
import EventByPredicate from './EventByPredicate';
import EventByIndividual from './EventByIndividual';
import EventsByTimePeriod from './EventsByTimePeriod';
import EventsByFixedTimeScheduler from './EventsByFixTimeScheduler';
import EventByInference from './EventByInference';
import EventByMacros from './EventByMacros';
import EventByGraphTrigger from './EventByGraphTrigger';

import { EventsContext } from '../EventsContext';
import { CONCEPT_SUBSCRIBER, VALUE_EXPRESSION, PREDICATE_SUBSCRIBER, PERIOD_SCHEDULER, FIXED_TIME_SCHEDULER, INFERENCE, PREDICATE_MACROS, GRAPH_TRIGGER } from '../EventsPage';

import _get from 'lodash/get';
import EventByPredicateBox from './EventByPredicateBox';

const styles = {
  ...CommonStyles,
  ...EventsStyles,
};

export default withStyles(styles)(props => {
  const {
    events,
    classes,
    currentTab,
    filterByPids,
    filterByConcept,
    filteredEventIds,
  } = props;

  const {
    nodesData,
    createEvent,
    addNodeToNodesData,
  } = useContext(EventsContext);

  const eventsByPredicate = events[PREDICATE_SUBSCRIBER];
  const eventsByMacros = events[PREDICATE_MACROS];
  const eventsByValueExpression = events[VALUE_EXPRESSION];
  const eventsByGraphTrigger = events[GRAPH_TRIGGER];
  const eventsByInference = events[INFERENCE];
  const eventsByIndividual = events[CONCEPT_SUBSCRIBER];
  const eventsByTimePeriod = events[PERIOD_SCHEDULER];
  const eventsByFixedTimeScheduler = events[FIXED_TIME_SCHEDULER];

  const areThereAnyEventsByCid = (type, cid) => {
    if (!events[type] || !Array.isArray(events[type][cid])) return;

    const eventIds = events[type][cid].map(e => e.id);
    return eventIds.some(id => filteredEventIds[type].includes(id));
  };

  const areThereAnyEventsByType = (type) => {
    if (!filteredEventIds || !events[type]) return false;

    if (type === GRAPH_TRIGGER) {
      const eventIds = events[type].map(e => e.id);
      return eventIds.some(id => filteredEventIds[type].includes(id));
    } else {
      for (const cid of Object.keys(events[type])) {
        const doesExist = areThereAnyEventsByCid(type, cid);
        if (doesExist) return true;
      }
    }
  };

  const areTherePredicateSubscriber = areThereAnyEventsByType(PREDICATE_SUBSCRIBER);
  const areTherePredicateMacros = areThereAnyEventsByType(PREDICATE_MACROS);
  const areThereValueExpression = areThereAnyEventsByType(VALUE_EXPRESSION);
  const areThereGraphTrigger = areThereAnyEventsByType(GRAPH_TRIGGER);
  const areThereInference = areThereAnyEventsByType(INFERENCE);
  const areThereConceptSubscriber = areThereAnyEventsByType(CONCEPT_SUBSCRIBER);

  return (
    <div style={{ marginBottom: '250px' }}>
      <React.Fragment>
        {!filteredEventIds &&
          tobeor(currentTab, [CONCEPT_SUBSCRIBER, INFERENCE, PREDICATE_SUBSCRIBER]) &&
            !Object.keys(events[currentTab]).includes('draft') && (
          <div>
            {currentTab === CONCEPT_SUBSCRIBER &&
              <div className={classes.mb5}>
                <CreateNewSubBtn
                  type={CONCEPT_SUBSCRIBER}
                  onClick={() => {
                    createEvent('draft', CONCEPT_SUBSCRIBER);
                  }}
                />
              </div>}

              {currentTab === INFERENCE &&
                <div className={classes.mb5} style={{ width: '1000px' }}>
                  <CreateNewSubBtn
                    type={INFERENCE}
                    onClick={() => {
                      addNodeToNodesData(filterByConcept);
                      createEvent('draft', INFERENCE);
                    }}
                  />
                </div>
              }

              {currentTab === PREDICATE_SUBSCRIBER &&
                <div className={classes.mb5}>
                  <CreateNewSubBtn
                    type={PREDICATE_SUBSCRIBER}
                    onClick={() => {
                      addNodeToNodesData(filterByConcept);
                      createEvent('draft', PREDICATE_SUBSCRIBER);
                    }}
                  />
                </div>
              }
          </div>
        )}

        {eventsByPredicate && (currentTab === PREDICATE_SUBSCRIBER || areTherePredicateSubscriber) &&  (
          <div>
            {areTherePredicateSubscriber ? (
              <div className={`${classes.mt20} ${classes.columnHeadingGeneral}`}>
                PREDICATE_SUBSCRIBER
              </div>
            ) : null}

            {eventsByPredicate.draft ?
              <EventByPredicate
                key={eventsByPredicate.draft.draft_id}
                sub={eventsByPredicate.draft}
              />
            : null}

            {Object.keys(eventsByPredicate).map((conceptId) => {

              if (filteredEventIds && !areThereAnyEventsByCid(PREDICATE_SUBSCRIBER, conceptId)) return null;

              const node = nodesData[conceptId];

              if ((filterByConcept && Number(conceptId) !== filterByConcept.id) || !node) return null;

              return (
                <div key={conceptId}>
                  <div>
                    <Node size="sm" isLink node={node} className={classes.mt20}/>

                    <div className={classes.headingContainer}>
                      <div className={classes.predIdsCol}>
                        <span className={classes.columnHeadingGeneral}>Id</span>
                      </div>

                      <div className={classes.predSubsCol}>
                        <span className={classes.columnHeadingGeneral}>Subscribers</span>
                      </div>

                      <div className={classes.predEventCell}>
                        <span className={classes.columnHeadingGeneral}>Event</span>
                      </div>

                      <div className={classes.predSubCell}>
                        <span className={classes.columnHeadingGeneral}>Subscription</span>
                      </div>

                      <div className={classes.predScriptCell}>
                        <span className={classes.columnHeadingGeneral}>Script (Function)</span>
                      </div>
                    </div>

                    {Array.isArray(eventsByPredicate[conceptId]) &&
                      eventsByPredicate[conceptId].map((sub, subIndex) => {
                      if (filteredEventIds && !filteredEventIds[PREDICATE_SUBSCRIBER].includes(sub.id))
                        return null;

                      return (
                        <EventByPredicate
                          key={subIndex}
                          sub={sub}
                          ancestor={conceptId}
                        />
                      );
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {eventsByMacros && (currentTab === PREDICATE_MACROS || areTherePredicateMacros) && (
          <div>
            {areTherePredicateMacros ? (
              <div className={`${classes.mt20} ${classes.columnHeadingGeneral}`}>
                PREDICATE_MACROS
              </div>
            ) : null}

            {Object.keys(eventsByMacros).map(conceptId => {
              if (filteredEventIds && !areThereAnyEventsByCid(PREDICATE_MACROS, conceptId)) return null;

              const node = nodesData[conceptId];

              if (filterByConcept && Number(conceptId) !== filterByConcept.id) return null;
              return (
                <div key={conceptId}>
                  <div>
                    <Node size="sm" isLink node={node} className={classes.mt20} />
                    <div className={classes.individsConceptCol}></div>
                    <div>
                      {eventsByMacros[conceptId].map((event, subIndex) => {
                        if (filteredEventIds && !filteredEventIds[PREDICATE_MACROS].includes(event.id))
                          return null;

                        return (
                          <EventByMacros
                            nodesData={nodesData}
                            key={event.id || subIndex}
                            sub={event}
                            ancestor={conceptId}
                            editable={event.editable}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {eventsByValueExpression && (currentTab === VALUE_EXPRESSION || areThereValueExpression) &&  (
          <div>
            {areThereValueExpression ? (
              <div className={`${classes.mt20} ${classes.columnHeadingGeneral}`}>
                VALUE_EXPRESSION
              </div>
            ) : null}

            <EventByPredicateBox
              classes={classes}
              nodesData={nodesData}
              filterByPids={filterByPids}
              events={eventsByValueExpression}
              filterByConcept={filterByConcept}
              filteredEventIds={filteredEventIds}
              areThereAnyEventsByCid={areThereAnyEventsByCid}
            />
          </div>
        )}

        {!filteredEventIds && currentTab === GRAPH_TRIGGER && (
          <div className={classes.mb10}>
            <CreateNewSubBtn type={GRAPH_TRIGGER} subName={'Graph trigger'} onClick={() => createEvent(null, GRAPH_TRIGGER)} />
          </div>
        )}

        {eventsByGraphTrigger && (currentTab === GRAPH_TRIGGER || areThereGraphTrigger) && (
          <div>
            {areThereGraphTrigger ? (
              <div
                className={`${classes.mt20} ${classes.columnHeadingGeneral}`}
                style={{ marginBottom: '25px' }}
              >
                GRAPH_TRIGGER
              </div>
            ) : null}

            {eventsByGraphTrigger.map((event, eventIndex) => {
              if (filteredEventIds && !filteredEventIds[GRAPH_TRIGGER].includes(event.id)) return null;

              if (filterByConcept && Number(event.trigger.ancestor) !== filterByConcept.id) return null;

              return (
                <EventByGraphTrigger
                  key={event.id || eventIndex}
                  event={event}
                  editable={event.editable}
                />
              );
            })}
          </div>
        )}

        {eventsByInference && (currentTab === INFERENCE || areThereInference) && (
          <div>
            {areThereInference ? (
              <div className={`${classes.mt20} ${classes.columnHeadingGeneral}`}>
                INFERENCE
              </div>
            ) : null}

            {eventsByInference.draft ?
              <EventByInference
                key={eventsByInference.draft.draft_id}
                sub={eventsByInference.draft}
              />
            : null}

            {Object.keys(eventsByInference).map(conceptId => {
              if (filteredEventIds && !areThereAnyEventsByCid(INFERENCE, conceptId)) return null;

              const node = nodesData[conceptId];

              return (
                <div key={conceptId}>
                  <div>
                    <Node size="xs" isLink node={node} className={classes.mt20} />

                    <div className={classes.individsConceptCol}></div>

                    {Array.isArray(eventsByInference[conceptId]) && eventsByInference[conceptId].map((sub, subIndex) => {
                      if (filteredEventIds && !filteredEventIds[INFERENCE].includes(sub.id)) return null;

                      return (
                        <EventByInference
                          key={sub.id || subIndex}
                          sub={sub}
                        />
                      );
                    })}
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {eventsByIndividual && (currentTab === CONCEPT_SUBSCRIBER || areThereConceptSubscriber) &&  (
          <div>
            {areThereConceptSubscriber ? (
              <div className={`${classes.mt20} ${classes.columnHeadingGeneral}`}>
                CONCEPT_SUBSCRIBER
              </div>
            ) : null}

            {eventsByIndividual.draft ?
              <EventByIndividual
                key={eventsByIndividual.draft.draft_id}
                sub={eventsByIndividual.draft}
              />
            : null}

            {Object.keys(eventsByIndividual).map((conceptId) => {
              if (filteredEventIds && !areThereAnyEventsByCid(CONCEPT_SUBSCRIBER, conceptId)) return null;

              const node = nodesData[conceptId];

              return (
                <div key={conceptId}>
                  <Node size="xs" isLink node={node} className={classes.mt10} />

                  <div className={classes.headingContainer}>
                    <div className={classes.individsIdsCol}>
                      <span className={classes.columnHeadingGeneral}>Id</span>
                    </div>

                    <div className={classes.individsConceptCol}>
                      <span className={classes.columnHeadingGeneral}>Subscribers</span>
                    </div>

                    <div className={classes.individsEventCol}>
                      <span className={classes.columnHeadingGeneral}>Event</span>
                    </div>

                    <div className={classes.individsScriptCol}>
                      <span className={classes.columnHeadingGeneral}>Script (Function)</span>
                    </div>
                  </div>

                  {Array.isArray(eventsByIndividual[conceptId]) ?
                    eventsByIndividual[conceptId].map((sub, subIndex) => {
                    if (filteredEventIds && !filteredEventIds[CONCEPT_SUBSCRIBER].includes(sub.id))
                      return null;

                    return (
                      <EventByIndividual
                        key={subIndex}
                        sub={sub}
                      />
                    );
                  }) : null}
                </div>
              )
            })}
          </div>
        )}

        {currentTab === PERIOD_SCHEDULER && (
          <div className={classes.mt10}>
            <CreateNewSubBtn type={PERIOD_SCHEDULER} subName={'Period Scheduler'}  onClick={() => createEvent(null, PERIOD_SCHEDULER)} />
          </div>
        )}

        {(currentTab === PERIOD_SCHEDULER && !filteredEventIds
          && eventsByTimePeriod && eventsByTimePeriod.length > 0) ?
          <div className={classes.mt20}>
            <div className={classes.firsTimePeriodheadingContainer}>
              <div className={classes.periodIdsCol} style={{ width: '400px' }}>
                <span className={classes.columnHeadingGeneral}>Enabled</span>
              </div>

              <div className={classes.functionPeriodCol}>
                <span className={classes.columnHeadingGeneral}>Script (Function)</span>
              </div>

              <div className={classes.editPeriodCol}/>
            </div>

            {eventsByTimePeriod.map((sub, subIndex) => {
              return (
                <EventsByTimePeriod
                  key={subIndex}
                  sub={sub}
                  ancestor={null}
                />
              );
            })}
          </div>
        : null}

        {currentTab === FIXED_TIME_SCHEDULER && (
          <div className={classes.mt10}>
            <CreateNewSubBtn type={FIXED_TIME_SCHEDULER} subName={'Fixed Time Scheduler'} onClick={() => createEvent(null, FIXED_TIME_SCHEDULER)} />
          </div>
        )}

        {(currentTab === FIXED_TIME_SCHEDULER && !filteredEventIds
          && eventsByFixedTimeScheduler && eventsByFixedTimeScheduler.length > 0) ?
          <div className={classes.mt20}>
            <div className={classes.firsTimePeriodheadingContainer}>
              <div className={`${classes.alignCenter}`}>
                <div className={classes.periodIdsCol} style={{ width: '400px' }}>
                  <span className={classes.columnHeadingGeneral}>Enabled</span>
                </div>

                <div className={classes.functionPeriodCol}>
                  <span className={classes.columnHeadingGeneral}>Script (Function)</span>
                </div>
              </div>
              <div className={classes.editPeriodCol}/>
            </div>
      
            {eventsByFixedTimeScheduler.map((sub, subIndex) => {
              return (
                <EventsByFixedTimeScheduler
                  key={subIndex}
                  sub={sub}
                  ancestor={null}
                />
              );
            })}
          </div>
        : null}
      </React.Fragment>
    </div>
  );
});
